var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    width: "200px",
    height: "200px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_147",
    x1: -3.85575e-7,
    y1: 187.667,
    x2: 224.907,
    y2: 60.3723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#990AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D21EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#paint0_linear_24_147)",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 40,
    ry: 40,
    transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 128.536 102.976 C 128.064 103.934 127.442 104.799 126.694 105.556 L 103.557 129.271 C 102.492 130.362 101.504 131.886 99.98 131.886 C 98.401 131.886 97.395 130.28 96.293 129.151 L 73.255 105.553 C 73.136 105.437 73.005 105.296 72.884 105.156 C 70.298 102.252 69.802 98.056 71.625 94.48 L 97.725 43.243 C 98.233 42.455 99.063 42.011 99.98 42.011 C 100.896 42.011 101.721 42.451 102.205 43.19 L 115.285 68.874 L 128.367 94.558 C 129.742 97.25 129.806 100.4 128.536 102.976 Z M 100.771 147.39 L 35.599 81.012 L 35.391 80.799 C 34.909 80.412 34.354 80.214 33.756 80.214 C 32.883 80.249 32.115 80.629 31.643 81.258 C 31.199 81.847 31.068 82.611 31.271 83.423 L 50.237 148.806 C 50.691 150.367 51.424 151.817 52.432 153.103 C 52.553 153.268 52.688 153.426 52.819 153.58 C 55.071 156.194 58.468 157.631 61.99 157.631 C 63.356 157.631 64.74 157.418 66.081 156.963 C 75.846 153.727 86.07 151.909 96.491 151.575 C 97.374 151.507 98.252 151.455 99.125 151.411 C 99.849 151.372 100.52 151.024 100.955 150.459 C 101.383 149.908 101.547 149.212 101.416 148.541 C 101.335 148.139 101.118 147.752 100.775 147.395 L 100.771 147.39 Z M 167.631 80.619 C 167.631 80.623 167.629 80.624 167.628 80.623 C 166.801 80.059 165.752 80.095 164.655 80.751 C 164.475 80.859 164.31 80.991 164.163 81.141 L 108.346 138.091 C 107.414 139.039 107.41 140.527 108.336 141.475 L 118.1 151.479 C 119.258 152.668 120.746 153.478 122.411 153.831 C 126.838 154.765 131.233 155.992 135.48 157.476 C 136.464 157.82 137.491 157.989 138.523 157.989 C 139.802 157.989 141.08 157.728 142.301 157.205 C 144.405 156.345 146.224 154.988 147.56 153.271 C 148.559 151.991 149.302 150.54 149.76 148.967 L 168.731 83.553 C 168.808 83.249 168.837 82.944 168.813 82.683 C 168.813 81.854 168.371 81.082 167.635 80.617 C 167.634 80.616 167.631 80.617 167.631 80.619 Z",
    fill: "white",
    style: {},
    transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrone);
export default __webpack_public_path__ + "static/media/throne.d4af3ac8.svg";
export { ForwardRef as ReactComponent };